import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';
import CursoInteresseContainer from '../containers/curso-interesse';
import DadosInteressadoContainer from '../containers/dados-interessado';
import GrupoFamiliarContainer from '../containers/grupo-familiar';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import CONSTANTS from '../constants';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import actions from '../actions';



export default class Finalizar extends React.Component {

    componentDidMount() {
        document.querySelector(".scrollView").scrollIntoView({ behaviour: "smooth" });



    }

    handleChange = (e) => {

        this.props.setAceite(e.target.checked);
    };

    render() {

        return (
            <div>

                <FormGroup row>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.props.aceite}
                                onChange={this.handleChange}
                                value="ok"
                                color="primary"
                            />
                        }
                        label="Declaro sob as penas da lei, serem verdadeiros os dados fornecidos neste formulário e estou ciente de que a não veracidade das informações acarretará a anulação deste."
                    />

                </FormGroup>

                <FormGroup row>

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.props.aceiteRegulamento}
                                onChange={(e) => {this.props.setAceiteRegulamento(e.target.checked)}}
                                value="ok"
                                color="primary"
                            />
                        }
                        label={<span>Declaro ter lido o <a target='_blank' href='https://www.unoeste.br/Unocred'>Regulamento</a> do Programa UNOCRED.</span>}
                    />






                </FormGroup>


                <FormGroup row>

                    <FormControl className='item-form' >

                        <TextField

                            type="text"

                            style={{ width: "180px" }}
                            id="percDesejado"
                            label="Código de Verificação"
                            value={this.props.captcha}
                            onChange={this.props.handleChangeCaptcha}
                            margin="normal"


                        />
                        <img id='imgCaptchaFinanciamento' src='/bolsasfinanciamentos/unocred/GetCaptcha?cache=1' />
                    </FormControl>

                </FormGroup>

                <div>

                    {this.props.finalizando && this.props.progressoFinalizar}

                </div>




            </div>

        );
    }
}




// WEBPACK FOOTER //
// ./src/components/finalizar.js